( function( $ ) {

var pageId = "page-notifications",
	page = "#" + pageId;

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
  $page.find('#noti-mark-read').on('ajax:success', function() {
    tower.stack.load(location.href, {
      noCache: true,
      replace: true
    });
  });

  $page.on('ajax:success', '.notifications .mark-read', function(e) {
    $(e.currentTarget).closest('.notifications-group').addClass('read')
  })

  tower.scrollLoad($page, function() {
    var $lastNotification

    $lastNotification = $('.notifications-group:last')
    data = {
      till: $lastNotification.data('latest-notification-created-at'),
      till_id: $lastNotification.data('latest-notification-id')
    }

    return $.ajax({
      url: location.href,
      dataType: 'html',
      type: 'get',
      data: data,
      success: function( result ) {
        if ( result ) {
          $('.notifications').append(result);
          tower.adjustReadableTime();
        }
      }
    });
  });
});


})( jQuery );
